<template>
    <div class="empty-chat">
        <div class="empty-chat__icon">AI</div>
        <h3 class="empty-chat__title">Чем могу помочь?</h3>
        <p class="empty-chat__subtitle">Я ваш ассистент по управлению строительными проектами</p>

        <div class="empty-chat__tips">
            <div class="tip" v-for="tip in tips" :key="tip.title" @click="$emit('select', tip.example)">
                <div class="tip__header">
                    <span class="tip__icon">{{ tip.icon }}</span>
                    <span class="tip__title">{{ tip.title }}</span>
                </div>
                <p class="tip__text">{{ tip.example }}</p>
            </div>
        </div>
    </div>
</template>

<script setup>
import { defineEmits } from 'vue';

defineEmits(['select']);

const tips = [
    {
        icon: '🏗',
        title: 'Проекты',
        example: 'Покажи список моих проектов'
    },
    {
        icon: '👥',
        title: 'Компании',
        example: 'Найди мои компании'
    },
    {
        icon: '📋',
        title: 'Задачи',
        example: 'Какие задачи назначены на меня?'
    },
    {
        icon: '❓',
        title: 'Помощь',
        example: 'Что ты умеешь?'
    }
];
</script>

<style lang="scss" scoped>
.empty-chat {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex: 1;
    padding: 40px 20px;
    text-align: center;

    @media (max-width: 768px) {
        padding: 0 20px;
    }
}

.empty-chat__icon {
    width: 56px;
    height: 56px;
    border-radius: 16px;
    background: var(--color-blue);
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    font-weight: 700;
    margin-bottom: 16px;
}

.empty-chat__title {
    margin: 0 0 8px;
    font-size: 20px;
    font-weight: 600;
    color: var(--color-text);
}

.empty-chat__subtitle {
    margin: 0 0 32px;
    font-size: 14px;
    color: var(--color-text-dark);
}

.empty-chat__tips {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    width: 100%;
    max-width: 480px;
}

.tip {
    padding: 14px;
    border: 1px solid var(--color-border);
    border-radius: 12px;
    text-align: left;
    cursor: pointer;
    transition: all 0.2s;

    &:hover {
        border-color: var(--color-blue);
        background-color: var(--color-bg-dark);
    }
}

.tip__header {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 6px;
}

.tip__icon {
    font-size: 16px;
}

.tip__title {
    font-size: 13px;
    font-weight: 600;
    color: var(--color-text);
}

.tip__text {
    margin: 0;
    font-size: 12px;
    color: var(--color-text-dark);
    line-height: 1.4;
}
</style>
